import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        items: [],

        application: null,
        talent: null,
        audioFormat: null,

        current: localStorage.getItem('project_uuid')
    },

    getters: {
        items: state => {
            return state.items
        }
    },

    mutations: {
        setApplication (state, application) {
            state.application = application
        },
        setTalent (state, talent) {
            state.talent = talent
        },
        setFormat (state, format) {
            state.audioFormat = format
        },
        setItems (currentState, items) {
            currentState.items = items
        },
        addItem (currentState, item) {
            currentState.items.push(item)
        },
        updateItem (currentState, item) {
            for (var i = 0; i < currentState.items.length; i++) {
                if (currentState.items[i]._id === item._id) {
                Vue.set(currentState.items, i, item)
                }
            }
        },
        setCurrent (currentState, uuid) {
            localStorage.setItem('project_uuid', uuid)
            currentState.current = uuid
        },
        removeCurrent (state) {
            localStorage.removeItem('project_uuid')
            state.current = null
            state.application = null
            state.talent = null
            state.audioFormat = null
        }
    },

    actions: {
        fetch: ({commit, state}, data) => {
            let params = data || {};

            params.status = 'draft'
            params.account_id = Vue.auth.user.account.uuid

            let uri = '/projects'
            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Vue.axios.get(uri, {params: params})
                    
                    commit('setItems', res.data.records)
                    resolve(res.data)
                } catch (ex) {
                    reject(err);
                }
            })
        },
        create: ({commit, state}, {data}) => {
            let uri = '/projects'
            return new Promise((resolve, reject) => {
                Vue.axios.post(uri, data)
                    .then(res => {
                        commit('addItem', res.data)
                        resolve(res.data)
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
        },
        read: ({commit, state}, id) => {
            let uri = '/projects/' + id
            return new Promise((resolve, reject) => {
                Vue.axios.get(uri)
                    .then(res => {
                        let project = res.data;

                        if (project.talent) {
                            commit('setTalent', project.talent)
                        }
        
                        commit('prompt/setItems', project.prompts, { root: true })
        
                        if (project.application_type) {
                            commit('setApplication', project.application_type)
                        }
        
                        if (project.deliverable_format) {
                            commit('setFormat', project.deliverable_format)
                        }

                        commit('setCurrent', res.data.uuid)
                        resolve(res.data)
                    })
                    .catch(err => {
                        console.log(err)
                        reject(err)
                    })
            })
        },
        update: ({commit, state}, {data}) => {
            let uri = '/projects/' + data.id

            return new Promise((resolve, reject) => {
                Vue.axios.put(uri, data)
                    .then(res => {
                        let project = res.data;

                        if (project.talent) {
                            commit('setTalent', project.talent)
                        }
        
                        commit('prompt/setItems', project.prompts, { root: true })
        
                        if (project.application_type) {
                            commit('setApplication', project.application_type)
                        }
        
                        if (project.deliverable_format) {
                            commit('setFormat', project.deliverable_format)
                        }
                        resolve(res.data)
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
        },
        delete: ({commit}, id) => {
            let uri = '/projects/' + id

            return new Promise (async (resolve, reject) => {
                try {
                    const res = await Vue.axios.delete(uri)

                    resolve()
                } catch (ex) {
                    reject(ex)
                }
            })
        },
        submit: ({commit, state}, {data}) => {
            let uri = '/projects/' + data.id + '/submit'

            return new Promise((resolve, reject) => {
                Vue.axios.post(uri, data)
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        duplicate: ({commit}, project_id) => {
            let uri = '/projects/' + project_id + '/duplicate'

            return new Promise(async (resolve, reject) => {
                try {
                    const res = await Vue.axios.post(uri)

                    resolve(res)
                } catch (ex) {
                    reject(ex)
                }
            })
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./prompts/store/modules/Project.js
// module id = null
// module chunks = 